
const state = {

}
const getters = {

    
}
const mutations = {

}
const actions = {


}

export default {
    namespaced:"home",
    state,getters,mutations,actions
}


// WEBPACK FOOTER //
// ./src/store/homeStore.js